var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRenovation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    enableBackground: "new 0 0 40 40",
    xmlSpace: "preserve",
    viewBox: "6.96 9.42 26.08 21.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.851,19.248l-4.106-3.251v-4.396c0-0.274-0.225-0.5-0.5-0.5h-1.771c-0.274,0-0.5,0.226-0.5,0.5v2.202l-5.197-4.114  c-0.455-0.361-1.097-0.361-1.552,0L7.149,19.248c-0.216,0.171-0.252,0.486-0.082,0.703l0.932,1.176  c0.17,0.215,0.486,0.252,0.702,0.081L20,12.264l11.299,8.944c0.216,0.171,0.531,0.134,0.703-0.081l0.93-1.176  C33.104,19.734,33.067,19.419,32.851,19.248z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.256,20.461v9.621c0,0.275,0.225,0.5,0.5,0.5h16.488c0.275,0,0.5-0.225,0.5-0.5v-9.621L20,13.539L11.256,20.461z   M23.703,18.262l-1.693,1.692l0.231,1.278l1.279,0.231l1.693-1.692c0.528,1.144,0.33,2.539-0.613,3.482  c-0.922,0.921-2.279,1.135-3.408,0.65l-4.734,4.734c-0.448,0.448-1.174,0.448-1.622,0c-0.448-0.447-0.448-1.174,0-1.621l4.735-4.734  c-0.485-1.13-0.271-2.487,0.651-3.408C21.164,17.932,22.559,17.734,23.703,18.262z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRenovation);
export default __webpack_public_path__ + "static/media/icon-renovation.d0638cfe973ec7ccf3f91fd49e2f7ff0.svg";
export { ForwardRef as ReactComponent };